import { render, staticRenderFns } from "./ModuleCategory.vue?vue&type=template&id=5aa121aa&"
import script from "./ModuleCategory.vue?vue&type=script&lang=js&"
export * from "./ModuleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports